import {Component, OnInit} from '@angular/core';
import {AuthService} from './modules/user/services/auth/auth.service';
import {Router} from '@angular/router';
import {CurrentUserService} from './modules/user/services/current-user/current-user.service';
import {PreviousUrlService} from './modules/form-renderer/services/previous-url/previous-url.service';

@Component({
  selector: 'app-root',
  template: `
    <main>
      <router-outlet></router-outlet>
    </main>
  `,
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor() {

  }

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/app.component.ts